import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import I18n from '../I18n';

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0, 2, 0, 2)
  },
  subTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.3rem'
    }
  }
}));

const Header = () => {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <Typography
        className={classes.subTitle}
        variant='h5'
        align='center'
      >
	      {I18n('home.home_title')}
      </Typography>
    </div>
  );
};

export default Header;
